<dcu-add-new-form
  [info]="addInfo"
  (onSave)="addNewItem.onSave($event)"
  (onSaveClose)="addNewItem.onSaveClose($event)"
>
  <omni-customer-form
    [customer]="customer"
    [isEdit]="isEdit" [stationNo]="stationNo"
    [stationName]="stationName" #addContent>
  </omni-customer-form>
</dcu-add-new-form>
